'use client';

import { useRef } from 'react';
import { IPageEntry } from '@move-frontend/contentful';
import { useIntersectionObserver } from '../../../../ui';
import Navigation from '../../navigation/Navigation';
import {
	Container,
	StickyWrapper,
	NavigationContainer,
} from './StickyHeader.styles';
import {
	BusinessPageId,
	MCOCaresPageId,
	ORLPageId,
	PassengersPageId,
} from '../../../../features/app/pages/domain/constants/PageId';
import { useSearchData } from '../../../../common-data/useSearchData';
import { getReciteMeBarHeight } from '../../../../utils/getReciteMeBarHeight';

interface IStickyHeader {
	page?: IPageEntry;
}
export const StickyHeader = ({ page }: IStickyHeader) => {
	const stickyTop = getReciteMeBarHeight();

	const { isSearchOpen } = useSearchData();
	const ref = useRef<HTMLDivElement>(null);
	const intersect = useIntersectionObserver(ref, {
		threshold: 1,
		rootMargin: `${-stickyTop}px 0px 0px 0px`,
	});
	const isSticky = intersect?.isIntersecting === false;
	const isHomepage =
		page?.fields.id === PassengersPageId.Home ||
		page?.fields.id === BusinessPageId.Home ||
		page?.fields.id === ORLPageId.Home ||
		page?.fields.id === MCOCaresPageId.Home;

	return (
		<Container
			id="sticky-container"
			ref={ref}
			isSticky={isSticky || isSearchOpen}
		>
			{/* Fixed on top */}
			<StickyWrapper
				id="sticky-wrapper"
				isSticky={isSticky || isSearchOpen}
				stickyTop={stickyTop}
			>
				<NavigationContainer
					isSearchOpen={isSearchOpen}
					isSticky={isSticky}
					isHomePage={isHomepage}
				>
					<Navigation isSticky={isSticky} />
				</NavigationContainer>
			</StickyWrapper>
		</Container>
	);
};
